// extracted by mini-css-extract-plugin
export default {"title":"MandatoryBlock_title__lxrc6","description":"MandatoryBlock_description__ACw0Q"};